<template>
    <div class="matching-check">
        <div class="d-flex align-center justify-space-between pa-4">
            <div class="font-weight-bold text-h5">お見合チェック</div>
            <v-btn class="info btn-print" type="button" @click="onPrint"> 印刷する</v-btn>
        </div>
        <div class="d-flex justify-space-between align-center px-4 mb-4">
            <v-flex xs12 md6 class="d-flex align-center justify-start">
                <div class="mr-8">
                    <div class="caption">
                        入会日
                    </div>
                    <div class="font-weight-bold">
                        {{ customer.contract_date ? contract_date : '' }}
                    </div>
                </div>
                <div class="mr-8">
                    <v-autocomplete v-model="family_name" label="対象会員名" @keydown="focusCustomerName($event)"
                        @update:search-input="debounce" @input="inputCustomerName" :items="itemCustomerFamilyNames"
                        @blur="blurName($event)" auto-select-first></v-autocomplete>
                </div>
                <div class="mr-10">
                    <div class="caption">
                        年齢
                    </div>
                    <div class="font-weight-bold">
                        {{ customer.birthday ? (calcAge(customer.birthday) + '歳') : '' }}
                    </div>
                </div>
                <div>
                    <v-btn dark class="info mr-2 btn-to-history" :to="`/customer/history/${customer.id}`"
                        target="_blank" :disabled="customer.id == null">
                        経緯表
                    </v-btn>
                </div>
            </v-flex>
            <v-flex xs12 md6 class="d-flex align-center justify-end" style="max-width: 300px">
                <v-autocomplete v-model="partner_family_name" label="紹介＆見合" @keyup="removeConnectName($event)"
                    @keydown="focusPartnerName($event)" @update:search-input="debouncePartner" @input="inputPartnerName"
                    :items="itemPartnerFamilyNames" @blur="blurPartnerName($event)"
                    :disabled="customer.id == null && connect_name == null" auto-select-first></v-autocomplete>
            </v-flex>
        </div>
        <v-card-text>
            <v-data-table :headers="headers" :items="customerPartners" :loading="loading" hide-default-footer
                class="elevation-1 partner-table" no-data-text="対象会員との履歴はありません" :items-per-page="limit"
                :header-props="{ sortIcon: null }" hide-default-header>
                <template v-slot:header="{ props: { headers } }">
                    <thead>
                        <tr>
                            <th v-for="item in headers" :key="item.value" class="column"
                                :class="{ 'cursor-pointer': item.sortable }"
                                :colspan="item.value == 'personal_results' ? 2 : 1"
                                @click="item.sortable ? customSort(item.value) : ''">

                                <span :class="{ 'active-sort': item.value == activeSortApi }">
                                    <v-row class="d-flex align-center" :class="{ 'justify-center': item.value == 'personal_results' }" style="margin: 0">
                                        <span>{{ item.text}}</span>
                                        <span v-if="item.sortable && activeSortApi != item.value"
                                            style="width: 24.01px; height: 24.01px;">
                                        </span>
                                        <v-icon v-if="item.sortable && item.value == activeSortApi" color="black">
                                            mdi-menu-down
                                        </v-icon>
                                    </v-row>
                                </span>
                            </th>
                        </tr>
                    </thead>
                </template>
                <template v-slot:item="{ item }">
                    <tr :class="{ 
                        'arranged-meeting-date': item.arranged_meeting_date == '見合実施',
                        'not-executed': item.is_default
                        }">
                        <td>{{ item.no }}</td>
                        <td>{{ item.kind !== CUSTOMER.EXEC_KIND.VAL.MATCHING ? item.partner_selection_day : '-' }}</td>
                        <td>
                            <u v-if="!item.isSame" style="cursor: pointer;"
                            @click="redirectToHistory(item.customerId)">{{item.member_name }}</u>
                            <u v-else :class="{ 'text-red': item.isSame }" style="cursor: pointer;"
                            @click="redirectToHistory(item.customerId)">{{item.member_name }}</u>
                        </td>
                        <template v-if="item.is_default">
                            <td class="text-center" colspan="2">
                                お見合い(不履行)
                            </td>
                        </template>
                        <template v-else-if="item.kind !== CUSTOMER.EXEC_KIND.VAL.MATCHING">
                            <td class="text-center">
                                {{ item.personal_results }}
                            </td>
                            <td class="text-center">
                                {{ item.partner_result }}
                            </td>
                        </template>
                        <template v-else>
                            <td class="text-center" colspan="2">
                                お見合い
                            </td>
                        </template>
                        <td>
                            {{ item.is_default ? '' : item.arranged_meeting_date }}
                        </td>
                        <td>
                            {{ calcAge(item.age) == 0 ? '' : calcAge(item.age) }}
                        </td>
                        <td>
                            {{ item.course }}
                        </td>
                        <td>
                            {{ item.work_holidays }}
                        </td>
                        <td>
                            {{ item.other_shop }}
                        </td>
                    </tr>
                </template>
            </v-data-table>
            <v-pagination v-model="currentPage" :length="total" v-if="total > 1" @input="reloadList"></v-pagination>
        </v-card-text>
    </div>

</template>

<script>
import utilDatetime from "@/utilities/datetime.js"
import moment from "moment";
import CUSTOMER from "@/consts/customer.js";

export default {
    title: "お見合チェック",
    name: "matching-check",
    mixins: [utilDatetime],
    data() {
        return {
            CUSTOMER: CUSTOMER,
            loading: false,
            currentPage: 1,
            total: null,
            limit: 100,
            isCustomerFamilyName: false,
            itemCustomerFamilyNames: [],
            isPartnerFamilyName: false,
            itemPartnerFamilyNames: [],
            family_name: "",
            family_name_old: "",
            partner_family_name: "",
            partner_family_name_old: "",
            customer_partner_id: null,
            customer_partner_name: null,
            customer_partner_connect_name: null,
            timer: null,
            timerPartner: null,
            connect_name: null,
            customer: {
                contract_date: null,
                birthday: null,
                id: null,
                gender: null,
                shop_id: null
            },
            partner: {
                id: null,
            },
            customers: [],
            partners: [],
            headers: [
                {
                    text: '№',
                    align: 'start',
                    sortable: false,
                    value: 'no',
                },
                { text: 'お相手選び日', sortable: true, value: 'partner_selection_day' },
                { text: '会員名', sortable: true, key: 'member_name', value: 'member_name' },
                { text: '自分 / 相手', sortable: false, value: 'personal_results' },
                { text: '見合実施日', sortable: false, value: 'arranged_meeting_date' },
                { text: '年齢', sortable: false, value: 'age' },
                { text: 'コース', sortable: false, value: 'course' },
                { text: '仕事休日', sortable: false, value: 'work_holidays' },
                { text: '他店舗', sortable: false, value: 'other_shop' },
            ],
            customerPartners: [],
            sortMemberName: 'member_name',
            sortPartnerSelectionDay: 'partner_selection_day',
            sort: 'desc',
            sortField: '&sort_by_name=true&sort=desc',
            activeSortApi: 'member_name',
            isMemberConnect: false
        }
    },
    computed: {
        contract_date() {
            return moment(this.customer.contract_date).format("yyyy/MM/DD");
        },
    },
    async beforeRouteUpdate(to, from, next) {
        this.currentPage = parseInt(to.query.page || 1);
        await this.listMatchingCheck();
        next();
    },
    watch: {
        sortField() {
            if (this.customer.id || this.isMemberConnect) {
                this.listMatchingCheck()
            }
        }
    },
    methods: {
        addStylePrint() {
            let file = document.createElement('link');
            file.id = 'matching-check'
            file.rel = 'stylesheet';
            file.href = 'assets/styles/print-matching-check.css'
            document.head.appendChild(file)
        },
        onPrint() {
            setTimeout(() => window.print(), 800)
            window.onafterprint = () => {
                document.getElementById('matching-check').remove()
            };
        },
        async reloadList() {
            this.loading = true
            this.listMatchingCheck()
            scrollTo(0, 0);
        },
        row_classes(item) {
            if (item.arranged_meeting_date == '見合実施') {
                return "grey"; //can also return multiple classes e.g ["orange","disabled"]
            }
        },
        blurName(e) {
            this.itemCustomerFamilyNames = [e.target.value]
            this.family_name = e.target.value
            this.isCustomerFamilyName = false
            this.loading = false
        },
        async debounce(e, timeout = 300) {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => { this.searchInputCustomerName(e) }, timeout);
        },
        focusCustomerName(e) {
            if (e.keyCode == 13) {
                this.connect_name = e.target.value
                this.customer_partner_connect_name = null
                this.customer = {
                    contract_date: null,
                    birthday: null,
                    id: null,
                    gender: null,
                    shop_id: null
                }
                this.listMatchingCheck()
                this.blurName(e)
            }
            this.isCustomerFamilyName = true;
        },
        async searchInputCustomerName(e) {
            if (!this.isCustomerFamilyName || e == null || e == '') {
                return
            }
            this.isMemberConnect = false
            this.loading = true
            const url = '/api/v1/customer/without-exit/by-name/' + e
            const response = await this.$axios.get(url)
            this.customers = response.data.customers
            this.itemCustomerFamilyNames = this.customers.map(item => {
                return item.family_name + item.given_name + ' (' + item.family_name_kana + item.given_name_kana + ')'
            })
            if (!this.customers.length) {
                this.isMemberConnect = true
            }

        },
        async inputCustomerName(e) {
            if (e == null) {
                this.family_name_old = null
                this.itemPartnerFamilyNames = []
                this.partner_name_old = null
                this.customer = {
                    contract_date: null,
                    birthday: null,
                    id: null,
                    gender: null,
                    shop_id: null
                }
                this.customerPartners = []
                this.total = 1
                this.currentPage = 1
                return
            }
            let customer
            customer = await this.customers.find(item => e == item.family_name + item.given_name + ' (' + item.family_name_kana + item.given_name_kana + ')')

            if (Object.keys(customer).length > 0) {
                this.itemCustomerFamilyNames = await [customer.family_name + customer.given_name]
                this.family_name = await customer.family_name + customer.given_name
                this.family_name_old = await customer.family_name + customer.given_name
                this.customer.contract_date = customer.contract_date
                this.customer.birthday = customer.birthday
                this.customer.id = customer.id
                this.customer.gender = customer.gender
                this.customer.shop_id = customer.shop_id
                this.connect_name = null
                this.listMatchingCheck()
            }

            this.isCustomerFamilyName = false;
        },

        blurPartnerName(e) {
            this.itemPartnerFamilyNames = [e.target.value]
            this.partner_family_name = e.target.value
            this.isPartnerFamilyName = false
            this.loading = false
        },
        async debouncePartner(e, timeout = 300) {
            clearTimeout(this.timerPartner);
            this.timerPartner = setTimeout(() => { this.searchInputPartnerName(e) }, timeout);
        },
        focusPartnerName(e) {
            if (e.keyCode == 13) {
                this.customer_partner_connect_name = e.target.value
                this.customer_partner_id = null
                this.listMatchingCheck()
                this.blurPartnerName(e)
            }
            this.isPartnerFamilyName = true;
        },
        async searchInputPartnerName(e) {
            if (!this.isPartnerFamilyName || e == null || e == '') {
                this.customer_partner_id = null
                if (this.customer.id != null && this.customer_partner_name != null) {
                    // this.listMatchingCheck()
                    return
                }
                return
            }

            this.loading = true
            let url = '/api/v1/customer/without-exit/by-name/' + e
            if (this.customer.gender != null) {
                url = url + '?gender=' + (this.customer.gender == CUSTOMER.GENDER.VAL.MALE ? CUSTOMER.GENDER.VAL.FEMALE : CUSTOMER.GENDER.VAL.MALE)
            }
            const response = await this.$axios.get(url)
            this.partners = response.data.customers
            this.itemPartnerFamilyNames = this.partners.map(item => {
                return item.family_name + item.given_name + ' (' + item.family_name_kana + item.given_name_kana + ')'
            })
        },
        async inputPartnerName(e) {
            const customer = await this.partners.find(item => e == item.family_name + item.given_name + ' (' + item.family_name_kana + item.given_name_kana + ')')

            if (Object.keys(customer).length > 0) {
                this.itemPartnerFamilyNames = await [customer.family_name + customer.given_name]
                this.partner_family_name = await customer.family_name + customer.given_name
                this.partner_family_name_old = await customer.family_name + customer.given_name
                this.customer_partner_id = await customer.id
                this.customer_partner_name = await customer.family_name + customer.given_name
                this.customer_partner_connect_name = null
                this.listMatchingCheck()
            }
            this.isPartnerFamilyName = false;
        },

        async listMatchingCheck() {
            this.customerPartners = []
            let url = '/api/v1/meet_check?limit=' + this.limit + '&offset=' + this.currentPage + this.sortField
            if (this.customer.id != null) {
                url += '&customer_target_id=' + this.customer.id
            }

            if (this.connect_name != null) {
                url += '&connect_name=' + this.connect_name
            }

            if (this.customer_partner_id != null) {
                url += '&customer_matching_id=' + this.customer_partner_id
            }

            if (this.customer_partner_connect_name != null) {
                url += '&customer_matching_connect_name=' + this.customer_partner_connect_name
            }
            const response = await this.$axios.get(url)
            this.currentPage = response.data.pagination.offset ? response.data.pagination.offset : 1
            this.total = response.data.pagination.totalPage ? response.data.pagination.totalPage : null
            this.itemPartnerFamilyNames = []
            this.partner_name_old = null
            this.customerPartners = response.data.customer_partner.map((customerPartner, key) => {
                return {
                    no: this.currentPage !== 1 ? ((this.currentPage - 1) * this.limit) + key + 1 : key + 1,
                    partner_selection_day: (customerPartner.customer_history && customerPartner.customer_history.target_date) ? moment(customerPartner.customer_history.target_date).format("yyyy/MM/DD") : '',
                    member_name: this.getNamePartner(customerPartner),
                    personal_results: this.getResult(customerPartner)[0] || "-",
                    partner_result: this.getResult(customerPartner)[1] || "-",
                    arranged_meeting_date: customerPartner.customer_history ? this.arrangedMeetingDate(customerPartner.statusArrangedMeetingDate, customerPartner.arranged_meeting_date) : '',
                    age: customerPartner.customer.birthday,
                    course: customerPartner.course_customer,
                    work_holidays: customerPartner.customer.holidays ? customerPartner.customer.holidays : '',
                    other_shop: this.customer.id && customerPartner.member_connect != null ? 'コネクト' : this.customer.shop_id != customerPartner.customer.shop_id ? customerPartner.customer.shop ? customerPartner.customer.shop.name : '' : '',
                    isSame: customerPartner.isDuplicate,
                    customerId: customerPartner.customer.id,
                    customer_history_id: customerPartner.customer_history_id,
                    kind: customerPartner.kind,
                    is_default: customerPartner.customer_history.status === CUSTOMER.STATUS_DEFAULT.getValue('不履行')
                }
            })
            this.customer_partner_name = null
            this.loading = false
        },
        redirectToHistory(customerId) {
            let url = `/customer/history/${customerId}`
            window.open(url, '_blank');
        },

        arrangedMeetingDate(status, arranged_meeting_date = null) {
            if (arranged_meeting_date) {
                switch (status) {
                    case CUSTOMER.STATUS_SRC_MATCHING_CHECK.getValue('仮予定'):
                        return moment(arranged_meeting_date).format("yyyy/MM/DD");
                    case CUSTOMER.STATUS_SRC_MATCHING_CHECK.getValue('予定'):
                        return moment(arranged_meeting_date).format("yyyy/MM/DD");
                    case CUSTOMER.STATUS_SRC_MATCHING_CHECK.getValue('実施'):
                        return '見合実施'
                    case CUSTOMER.STATUS_SRC_MATCHING_CHECK.getValue('不履行'):
                        return moment(arranged_meeting_date).format("yyyy/MM/DD");
                    default:
                        return ''
                }
            } else {
                return ''
            }

        },
        getNamePartner(partner) {
            if (this.customer.id && partner.member_connect != null) {
                const memberConnect = JSON.parse(partner.member_connect);
                return memberConnect.connect_name || "コネクト対象者";
            }
            return `${partner.customer.family_name} ${partner.customer.given_name}`;
        },
        customSort(sortName) {
            this.sort = 'desc'
            if (this.sortMemberName == sortName) {
                this.activeSortApi = 'member_name'
                this.sortField = '&sort_by_name=true&sort=' + this.sort
            }

            if (this.sortPartnerSelectionDay == sortName) {
                this.sortField = '&sort_by_date=true&sort=' + this.sort
                this.activeSortApi = 'partner_selection_day'
            }
        },
        removeConnectName(e) {
            if (e.target.value.length == 0) {
                this.customer_partner_connect_name = null
                this.listMatchingCheck()
            }
        },
        getResult(customerPartner) {
            let personal_results = [null, null]
            if (
                customerPartner.customer_history.type == CUSTOMER.TYPE_FORM.IN_HOUSE_MATCH
                || customerPartner.customer_history.type == CUSTOMER.TYPE_FORM.CONNECT_ARRANGEMENT
            ) {
                const options = JSON.parse(customerPartner.customer_history.json)
                if (options && options.result !== null) {
                    return [CUSTOMER.IN_HOUSE_AND_CONNECT_RESULTS.getName(options.result), CUSTOMER.IN_HOUSE_AND_CONNECT_RESULTS.getName(options.result)]
                }
            }
            if (this.customer.gender == CUSTOMER.GENDER.VAL.MALE) {
                personal_results[0] = customerPartner.male_result
                personal_results[1] = customerPartner.female_result
            } else {
                personal_results[0] = customerPartner.female_result
                personal_results[1] = customerPartner.male_result
            }
            return [CUSTOMER.INDIVIDUAL_RESULTS.getName(personal_results[0]), CUSTOMER.INDIVIDUAL_RESULTS.getName(personal_results[1])]
        }
    }
}
</script>
<style scoped lang="scss" media="print">
@import '/assets/styles/print-matching-check.css';
::v-deep .not-executed {
    background-color: #F0908D !important;
}

.text-red {
    color: red !important;
}

/* .partner-table table tr td:last-child {
    background-color: #fff !important;
} */

.btn-to-history.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg {
    background-color: #1e88e5 !important;
    color: #fff !important;
    opacity: 0.8;
}

.cursor-pointer {
    cursor: pointer;
}

.active-sort {
    font-weight: 700;
    color: #000000;
}
</style>
<style>
.arranged-meeting-date {
    background-color: #D8D8D8 !important;
}
</style>
